<template>
    <div>
        <div class="page-title">
            <h4>{{$t('txt.editeazaSablonOferta')}}</h4>
        </div>
        <form class="add-user-form" id="add-offer-template">
            <input type="hidden" name="_method" value="put" />
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                <div class="inner-location-group">
                    <div class="form-group">
                        <input type="text" class="form-control"
                               v-model="template.name"
                               placeholder=""
                               v-validate="'required'">
                        <label class=""> {{$t('placeholder.nume')}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                              <i class="fas fa-signature"></i>
                          </span>
                        <p class="custom-error-info"> {{errors.first('name')}} </p>
                    </div>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-12 form-group">
                <div class="location-header">
                    <h4> {{$t('placeholder.continut')}} </h4>
                </div>
                <div class="inner-location-group form-group">
                    <ckeditor :editor="editor" v-model="template.text" :config="editorConfig"></ckeditor>
                </div>
            </div>
            <div class="col-12">
                <div class="inner-location-group">
                    <div class="save-contact-buttons">
                        <button @click.prevent='saveTemplate()' :disabled="this.$store.state.loading">
                            <i class="fas fa-check"></i>
                            {{$t('placeholder.salveaza')}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import OfferTemplatesService from '../../api-services/offer-templates.service.js'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  name: 'EditOfferTemplate',
  data () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
      },
      form: {
        name: '',
        content: ''
      },
      template: {
        name: null,
        text: null
      }
    }
  },
  methods: {
    getTemplate () {
      return new Promise((resolve, reject) => {
        OfferTemplatesService.get(this.$route.params.id)
          .then((response) => {
            this.template = response.data.data
            console.log()
            // alert()
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    saveTemplate () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('add-offer-template'))
      if (this.template.name) {
        formData.append('name', this.template.name)
      }
      if (this.template.text) {
        formData.append('text', this.template.text)
      }
      OfferTemplatesService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.template = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.sablonModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
          this.$router.push({ name: 'offer-templates' })
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {},
  created () {
    this.$store.dispatch('hideLoading')
    this.getTemplate()
  }
}
</script>
